export const style = {
	container: {
		width: "100%",
	},
	progressWrapper: {
		display: "flex",
		justifyContent: "center",
	},
};
